import React, { useEffect } from 'react';
import { get } from 'lodash';
import styled from 'styled-components';
import { Dropdown, Button, Icon, Popup } from 'semantic-ui-react';

const Container = styled.div`
    display: flex;
    align-items: center;
    width: 400px;
`;

const GroupBy = ({ groupByColumns = [], tableObject, setGrouping }) => {
    const removeSelections = get(tableObject, ['tableProps', 'removeAllSelections'], () => null);
    let hasGroup = false;
    let currentGroupValue = tableObject.tableProps.state.groupBy;
    if (currentGroupValue.length > 0) {
        currentGroupValue = currentGroupValue[0];
        hasGroup = true;
    } else {
        currentGroupValue = ''; // setting it to '' will reset the semantic dropdown to the placeholder text
    }

    useEffect(() => {
        if (currentGroupValue) {
            setGrouping([currentGroupValue]);
        }
    }, [currentGroupValue, setGrouping]);

    const handleSelect = (value) => {
        setGrouping([currentGroupValue]);
        tableObject.tableProps.toggleGroupBy(currentGroupValue, false);
        tableObject.tableProps.toggleGroupBy(value, true);
        removeSelections();
    };
    const clearGroup = () => {
        tableObject.tableProps.toggleGroupBy(currentGroupValue, false);
        setGrouping([]);
        removeSelections();
    };
    return (
        <Container>
            <Popup
                content={hasGroup ? `Grouped By: ${currentGroupValue}` : 'Currently Ungrouped'}
                size='tiny' position='top center'
                trigger={<Icon name={`object ${hasGroup ? 'group' : 'ungroup'} outline`}
                    size='big'
                    disabled={!hasGroup}
                    style={{ marginRight: '5px' }} />}
            />
            <Dropdown
                fluid
                selection
                id='groupById'
                name='groupById'
                placeholder='Group By Mapping Type'
                value={currentGroupValue}
                options={groupByColumns.map(x => ({ key: x, text: x, value: x }))}
                onChange={(e, { value }) => handleSelect(value)}
            />
            <Button onClick={() => clearGroup()} disabled={!hasGroup} primary={hasGroup} size='small' style={{ marginLeft: '5px' }}>
                    Ungroup
            </Button>
        </Container>
    );
};
export default GroupBy;



// WEBPACK FOOTER //
// ./src/components/atoms/tables/smarttables/tablePlugins/GroupBy.js